/* eslint-disable aveny/no-color-rule */

import Box from '@mui/material/Box';
import RapportTypography from './RapportTypography';
import { IRapportNewPageControl } from './RapportMallTypes';
import { RapportKontrollHeader } from './RapportKontrollHeader';
import { SELECTED_SHADOW } from './RapportMallUtils';
export interface IProps {
  sx?: any;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onSelect?: (path: number[]) => void;
  onUpdate?: (updatedControl: any) => void;
  controlPath: number[];
  selected?: boolean;
}

export const RapportNewPage: React.FC<IProps> = props => {
  const { sx, onMouseEnter, onMouseLeave, onSelect, controlPath, selected } =
    props;
  const handleSelect = (e?: React.MouseEvent) => {
    if (e) e.stopPropagation();
    if (onSelect) {
      onSelect(controlPath);
    }
  };
  return (
    <Box
      sx={{
        boxShadow: selected ? SELECTED_SHADOW : undefined,
        boxSizing: 'border-box',
        background: '#f5f5f5',
        border: '1px dashed #aaa',
        textAlign: 'center',
        ...sx,
      }}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={handleSelect}
      data-control-path={props.controlPath.join('-')}
    >
      <RapportTypography>--- Ny sida ---</RapportTypography>
    </Box>
  );
};

export interface IRapportNewPageEditProps {
  value: IRapportNewPageControl;
  onChange: (ctrl: IRapportNewPageControl) => void;
}

export const RapportNewPageEdit: React.FC<IRapportNewPageEditProps> = props => (
  <Box sx={{ mt: 2 }}>
    <RapportKontrollHeader value={props.value} />
  </Box>
);
